import React,{useEffect,useState} from 'react'
import {Link,useNavigate} from "react-router-dom";
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
import axios from "../helper/axios";
import {useSelector,useDispatch} from "react-redux";
import {VendorAction} from "../action";


export default function AddProduct() {
  const navigate = useNavigate();
  const auth = useSelector(state=>state.auth);
  const [chooseFile,setChooseFile] = useState([]); 
  const [chooseFileVendor,setChooseFileVendor] = useState([]); 
  const [productName,setProductName] = useState("")
  const [linkName,setLinkName] = useState("")
  const [category,setCategory] = useState("")
  const [price,setPrice] = useState("")
  const [discount,setDiscount] = useState("")
  const [description,setDescription] = useState("")
  const [preview,setPreview] = useState([]);
  const [vendorId,setVendorId] = useState("");
  const maxLength = 5;

  // Banner Config States
  const [bannerType, setBannerType] = useState("image");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [targetUrl, setTargetUrl] = useState("/products?discount=yes");
  const [currentConfig, setCurrentConfig] = useState(null);

  const percentPrice =(price/100)*discount;
  const currentPrice =price-percentPrice;

const arrayofFiles=[]

  const onSelectFile=(e)=>{
      for (var i=0;i < e.target.files.length;i++){
        arrayofFiles.push(e.target.files[i]);
        
    }
    
  let images = [];
  arrayofFiles.map((e)=>{
  const ImageUrl =  URL.createObjectURL(e);
  images.push(ImageUrl)
      
  })
  setPreview(images)
  }
   const removeImageFromArray=(e)=>{
    const index = e.target.id;
    let newPreview = [...preview];

    newPreview.splice(index,1);
    setPreview(newPreview);
  }
 
  const uploadImages=async()=>{ 
    if (!startDate || !endDate) {
      alert("Ju lutem plotësoni datën e fillimit dhe datën e mbarimit!");
      return;
    }

    if (!chooseFile || chooseFile.length === 0) {
      alert("Ju lutem zgjidhni një file për baner!");
      return;
    }

    const formData = new FormData();
    Object.values(chooseFile).forEach(file=>{
      formData.append("multiFile", file);
    }); 
    formData.append("vendorEmail", auth?.user?.email || "");
    formData.append("linkName", linkName || "");
    formData.append("bannerType", bannerType);
    formData.append("startDate", startDate);
    formData.append("endDate", endDate);
    formData.append("isActive", isActive);
    formData.append("targetUrl", targetUrl || "/products?discount=yes");
    
    try {
      const res = await axios.post("/addbanner", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if(res.status===200){
        alert("Baneri u shtua me sukses! Mund të shtoni më shumë banera ose shikoni listën.");
        setStartDate("");
        setEndDate("");
        setTargetUrl("/products?discount=yes");
        setChooseFile([]);
        setPreview([]);
        loadBannerConfig();
      }
    } catch (error) {
      console.error("Error uploading banner:", error);
      const errorMessage = error.response?.data?.details || error.response?.data?.error || error.response?.data?.message || error.message || "Ka pasur një gabim gjatë upload-it të banerit!";
      alert(errorMessage);
    }
  }

  // Load current config
  const loadBannerConfig = async () => {
    try {
      const res = await axios.get("/getbannerconfig");
      if(res.status === 200 && res.data && Array.isArray(res.data)) {
        setCurrentConfig(res.data);
      } else if (res.status === 200 && res.data && !Array.isArray(res.data)) {
        setCurrentConfig([res.data]);
      } else {
        setCurrentConfig([]);
      }
    } catch (error) {
      console.error("Error loading banner config:", error);
      setCurrentConfig([]);
    }
  }

  const uploadImagesVendor=async()=>{ 
    const formData = new FormData();
    // formData.append("multiFile",chooseFile[0]); 
    Object.values(chooseFileVendor).forEach(file=>{
      console.log(file)
      formData.append("multiFileVendor", file);
    }); 
    formData.append("vendorId",vendorId)
    
    try {
      const res = await axios.post("/addbannervendor",formData, {headers: {
            'Content-Type': 'multipart/form-data'
          }});

      if(res.status===200){
        alert("Vendor Banner update Successfully");
        navigate("/vendorbanner")
      }
    } catch (error) {
      console.error("Error uploading vendor banner:", error);
      // Shfaq mesazhin e plotë të gabimit
      const errorMessage = error.response?.data?.details || error.response?.data?.error || error.response?.data?.message || error.message || "Ka pasur një gabim gjatë upload-it të vendor banerit!";
      alert(errorMessage);
    }
  }

    const vendor = useSelector(state=>state?.vendor);

  const dispatch = useDispatch();
  const vendorGetData=()=>{
    dispatch(VendorAction());
  }
  useEffect(()=>{
    vendorGetData();
    loadBannerConfig();
  },[])

	return (
	<div className="sidebar-mini skin-green-light">
		<div className="wrapper"> 
  		  <Header/> 
        {auth?.user?.role==="Vendor"?<VendorSidebar/>:<Sidebarr/>}
         
  {/* Content Wrapper. Contains page content */}
  <div className="content-wrapper">
    {/* Content Header (Page header) */}
    <section className="content-header">
      <h1>
        Add New Images
        <small>it all starts here</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <a href="#">
            <i className="fa fa-dashboard" /> Home
          </a>
        </li>
        <li>
          <a href="#">Product Manage</a>
        </li>
        <li className="active">All Product</li>
      </ol>
    </section>
    {/* Main content */}
    <section className="content">
      {/* Default box */}
      <div className="box">
        <div className="box-header with-border"> 
          <div className="box-tools pull-right">
            <Link
              to="/banner"
              type="button"
              className="btn btn-success"
              data-toggle="tooltip"
              title="View"
            >
              <i className="fa fa-eye" />
              {" View Banner "}
            </Link>
            {" "}
            {/*<Link to="/upload"
              type="button"
              className="btn btn-primary"
              data-toggle="tooltip"
              title="Upload"
            >
              <i className="fa fa-upload" />{" "}
              {"Bulk Upload"}
            </Link>*/}
          </div>
        </div>
        <div className="box-body">
        <div className="col-md-6">
         
  
  <div className="box-body">
  <p>Shto baner të ri (çdo baner ka datë fillimi/mbarimi dhe link të vet për zbritje)</p>
    <div className="row ">
      <div className="col-xs-12">
        <label>Lloji i Banerit:</label>
        <select 
          className="form-control"
          value={bannerType}
          onChange={(e)=>setBannerType(e.target.value)}
        >
          <option value="image">Foto</option>
          <option value="video">Video</option>
        </select>
      </div>
    </div>
    <br/>
    <div className="row ">
          <div className="col-xs-6">
        <label>Upload File:</label>
        <input 
          type="file" 
          className="form-control"
          accept={bannerType === "image" ? "image/*" : "video/*"}
          name="multiFile"
          onChange={(e)=>setChooseFile(e.target.files)}
        />
      </div>
      <div className="col-xs-6">
        <label>URL Link (ku të çon baneri):</label>
        <input 
          type="text" 
          className="form-control"
          placeholder="/products?discount=yes" 
          value={targetUrl}
          onChange={(e)=>setTargetUrl(e.target.value)}
        />
      </div> 
 

    </div> 
    <br/>
    <div className="row ">
      <div className="col-xs-6">
        <label>Data Fillimi:</label>
        <input 
          type="date" 
          className="form-control"
          value={startDate}
          onChange={(e)=>setStartDate(e.target.value)}
          required
        />
      </div>
      <div className="col-xs-6">
        <label>Data Mbarimi:</label>
        <input 
          type="date" 
          className="form-control"
          value={endDate}
          onChange={(e)=>setEndDate(e.target.value)}
          required
        />
        <small className="text-muted">(Do të shfaqet deri në 23:59 të kësaj date; mund të zgjidhni edhe datë në të kaluarën)</small>
      </div> 
    </div>
    <br/>
    <div className="row ">
      <div className="col-xs-12">
        <label>
          <input 
            type="checkbox" 
            checked={isActive}
            onChange={(e)=>setIsActive(e.target.checked)}
          /> 
          {" "}Aktiv (Baneri do të shfaqet nëse data është e saktë)
        </label>
      </div>
    </div>
    <br/>
    {currentConfig && currentConfig.length > 0 && (
      <div className="row ">
        <div className="col-xs-12">
          <div className="alert alert-info">
            <strong>Banera aktualë ({currentConfig.length}):</strong>
            <ul style={{ marginBottom: 0 }}>
              {currentConfig.map((c, i) => (
                <li key={c._id || i}>
                  Lloji: {c.bannerType || "image"} | 
                  Fillimi: {c.startDate ? new Date(c.startDate).toLocaleDateString() : "N/A"} | 
                  Mbarimi: {c.endDate ? new Date(c.endDate).toLocaleDateString() : "N/A"} | 
                  {c.isActive ? "Aktiv" : "Jo aktiv"}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    )}
  </div>
  
  <div className="box-body">
    <div className="row "> 
      <div className="col-xs-6">
        <button className="btn btn-primary" onClick={(e)=>uploadImages()}>Shto Baner</button>
      </div>  
    </div> 
  </div>
  
  {/* /.box-body */}
 
</div> 
</div>

        {/* /.box-body */}
        {/*<div className="box-footer">Footer</div>*/}
        {/* /.box-footer*/}
      </div>
      {/* /.box */}
    </section>  {/* Main content */}
    <section className="content">
      {/* Default box */}
      <div className="box">
        <div className="box-header with-border"> 
          <div className="box-tools pull-right">
            <Link
              to="/vendorbanner"
              type="button"
              className="btn btn-success"
              data-toggle="tooltip"
              title="View"
            >
              <i className="fa fa-eye" />
              {" View Vendor Banner "}
            </Link>
            {" "}
            {/*<Link to="/upload"
              type="button"
              className="btn btn-primary"
              data-toggle="tooltip"
              title="Upload"
            >
              <i className="fa fa-upload" />{" "}
              {"Bulk Upload"}
            </Link>*/}
          </div>
        </div>
        <div className="box-body">
          <div className="box-body">
  <p>Add Vendor Banner</p>
    <div className="row ">

      <div className="col-xs-6">
        <select type="text" 
               className="form-control"
               placeholder="Url Link" 
               onChange={(e)=>setVendorId(e.target.value)}
          >

          <option>Choose Vendors </option>
          {vendor?.vendor?.map(vd=>(
          <option value={vd._id}>{vd.fname}</option>
          ))}
          </select>
      </div> 
          <div className="col-xs-6">
        <input type="file" 
               className="form-control"
               placeholder=".col-xs-5" 
               multiple 
               name="multiFileVendor"
          // onChange={onSelectFile}
          onChange={(e)=>setChooseFileVendor(e.target.files)}/>
      </div>
 

    </div> 
  </div>
  
  <div className="box-body">
    <div className="row "> 

      <div className="col-xs-6">
        <button className="btn btn-primary" onClick={(e)=>uploadImagesVendor()}>Update Vendor Banner</button>
      </div>  

    </div> 
  </div>
</div>

        {/* /.box-body */}
        {/*<div className="box-footer">Footer</div>*/}
        {/* /.box-footer*/}
      </div>
      {/* /.box */}
    </section>
    {/* /.content */}
  </div>
  {/* /.content-wrapper */}
 


       <Footer/>
       <Tool/> 
   
  <div className="control-sidebar-bg" />
</div>

			
		</div>
	)
}